export default {
    convert_object_string_vals : function (object) {
        if(typeof(object) !== 'object') {
            return object;
        }

        for(var i in object) {
            if(typeof(object[i]) === 'object') {
                object[i] = this.convert_object_string_vals(object[i]);
            } else {
                if(object[i] === 'true') {
                    object[i] = true;
                } else if (object[i] === 'false') {
                    object[i] = false;
                } else if (!isNaN(parseFloat(object[i]))) {
                    object[i] = parseFloat(object[i]);
                }
            }
        }

        return object;
    },
    ltrim_character : function (character, string) {
        if(typeof(string) !== 'string') {
            return false;
        }

        if(Array.isArray(character)) {
            for(var c in character) {
                if(string[0] == character[c]) {
                    return string.substring(1);
                }
            }
        } else {
            if (string[0] == character) {
                return string.substring(1);
            }
        }

        return string;
    },
    rtrim_character : function (character, string) {

        if(typeof(string) !== 'string') {
            return false;
        }

        if(Array.isArray(character)) {
            for(var c in character) {
                if(string[string.length - 1] == character[c]) {
                    return string.substring(0, string.length - 1);
                }
            }
        } else {
            if (string[string.length - 1] == character) {
                return string.substring(0, string.length - 1);
            }
        }

        return string;
    },
    trim_character : function (character, string) {
        return this.rtrim_character(character, this.ltrim_character(character, string));
    },
}



// WEBPACK FOOTER //
// ./js/utils/utils.js